/**
 * icons — SVG inner-HTML strings used by ToolsPanelButton.
 *
 * Each entry is the *inner* content of a 24×24 stroke-1 SVG. The
 * ToolsPanelButton wraps these with a parent <svg> via
 * `dangerouslySetInnerHTML`, so consumers just pass the string.
 *
 * Extracted verbatim from the legacy DesktopLayout `I` object so the
 * Word-export and tools panel keep their existing iconography.
 */

export const ICON_IMPORT =
  '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>' +
  '<polyline points="17 8 12 3 7 8"/>' +
  '<line x1="12" y1="3" x2="12" y2="15"/>'

export const ICON_PRINT =
  '<polyline points="6 9 6 2 18 2 18 9"/>' +
  '<path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/>' +
  '<rect x="6" y="14" width="12" height="8"/>'

export const ICON_DOWNLOAD =
  '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>' +
  '<polyline points="7 10 12 15 17 10"/>' +
  '<line x1="12" y1="15" x2="12" y2="3"/>'

export const ICON_ARCHIVE =
  '<path d="M21 8v13H3V8"/>' +
  '<path d="M1 3h22v5H1z"/>' +
  '<path d="M10 12h4"/>'

export const ICON_ALERT =
  '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>' +
  '<line x1="12" y1="9" x2="12" y2="13"/>' +
  '<line x1="12" y1="17" x2="12.01" y2="17"/>'

export const ICON_POSTING =
  '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>' +
  '<rect x="8" y="2" width="8" height="4" rx="1"/>'

export const ICON_USERS =
  '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>' +
  '<circle cx="9" cy="7" r="4"/>' +
  '<path d="M23 21v-2a4 4 0 0 0-3-3.87"/>' +
  '<path d="M16 3.13a4 4 0 0 1 0 7.75"/>'

export const ICON_USER_X =
  '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>' +
  '<circle cx="12" cy="7" r="4"/>' +
  '<line x1="18" y1="8" x2="23" y2="13"/>' +
  '<line x1="23" y1="8" x2="18" y2="13"/>'

export const ICON_SEARCH =
  '<circle cx="11" cy="11" r="8"/>' +
  '<line x1="21" y1="21" x2="16.65" y2="16.65"/>'

export const ICON_AUDIT =
  '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>' +
  '<polyline points="14 2 14 8 20 8"/>'

export const ICON_SETTINGS =
  '<circle cx="12" cy="12" r="3"/>' +
  '<path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/>'

export const ICON_CLOCK =
  '<circle cx="12" cy="12" r="10"/>' +
  '<polyline points="12 6 12 12 16 14"/>'
